import httpClient from 'shared/lib/httpClient';

export const createRole = async (payload) => {
  const response = await httpClient.post('/company-roles', payload);
  return response?.data;
};
